<template>

  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--添加支付-->
      <div class="common-form">新增支付</div>
      <!-- 选择店铺 -->
      <!-- <el-form-item label="选择店铺 ">
        <el-select v-model="form.port_id" placeholder="请选择店铺" @change="choosePort()">
          <el-option v-for="(item,index) in list" :key="item.port_id" :label="item.port_name" :value="item.port_id">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="名称 " prop="name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.name" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="简介 " prop="introduce" >
        <el-input v-model="form.introduce" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="缩略图" :rules="[{required: true,message: '请输入上传缩略图'}]">
        <el-button @click="chooseImg">选择图片</el-button>
        <img class="mt10" v-img-url="form.file_url" width="200">
      </el-form-item>

      <!-- <el-form-item label="支付类型值" :rules="[{required: true,message: '请输入支付类型值'}]">
        <el-input-number v-model="form.value" :step="10" step-strictly :min="10"></el-input-number>
      </el-form-item> -->

      <el-form-item label="支付类型 ">
        <el-select v-model="form.payment_type" placeholder="请选择">
          <el-option v-for="(item,index) in payment_arr" :key="index" :label="item" :value="index">
          </el-option>
        </el-select>
        <div class="tips">目前支持 微信支付、支付宝支付和汇付</div>
      </el-form-item>


      <!-- 支付宝支付 -->
      <div v-if="form.payment_type=='40-alipay_app' || form.payment_type=='40-alipay_h5'">
        <el-form-item label="支付宝 appid"  prop="alipay.appid" :rules="[{required: true,message: ' '}]">
          <el-input v-model="form.alipay.appid" class="max-w460"></el-input>
          <div class="tips"></div>
        </el-form-item>

        <el-form-item label="支付宝公钥">
          <el-input type="textarea" :rows="4" v-model="form.alipay.publicKey" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="应用私钥">
          <el-input type="textarea" :rows="4" v-model="form.alipay.privateKey" class="max-w460"></el-input>
        </el-form-item>
      </div>

      <!-- 微信支付 -->
      <div v-if="form.payment_type=='20-wx_mn' || form.payment_type=='20-wx_mp' || form.payment_type=='20-wx_app'">
        <el-form-item label="微信支付商户号 MCHID">
          <el-input v-model="form.wechatpay.mchid" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="微信支付密钥 APIKEY ">
          <el-input v-model.trim="form.wechatpay.apikey" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="微信appid" v-if="form.payment_type=='20-h5' || form.payment_type=='20-wx'">
          <el-input v-model.trim="form.wechatpay.wxapp_id" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="微信appid" v-if="form.payment_type=='20-app'">
          <el-input v-model.trim="form.wechatpay.app_id" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="apiclient_cert.pem">
          <el-input type="textarea" :rows="4" placeholder="使用文本编辑器打开apiclient_cert.pem文件，将文件的全部内容复制进来" v-model.trim="form.wechatpay.cert_pem" class="max-w460"></el-input>
          <div class="tips">使用文本编辑器打开apiclient_key.pem文件，将文件的全部内容复制进来</div>
        </el-form-item>
        <el-form-item label="apiclient_key.pem">
          <el-input type="textarea" :rows="4" placeholder="使用文本编辑器打开apiclient_cert.pem文件，将文件的全部内容复制进来" v-model.trim="form.wechatpay.key_pem" class="max-w460"></el-input>
          <div class="tips">使用文本编辑器打开apiclient_key.pem文件，将文件的全部内容复制进来</div>
        </el-form-item>
      </div>

      <!-- 银联支付 -->
      <div v-if="form.payment_type=='unionpay'">
        <el-form-item label="商户号(mid)">
          <el-input v-model="form.unionpay.mid" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="终端号(tid)">
          <el-input v-model="form.unionpay.tid" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="机构商户号(instMid)">
          <el-input v-model="form.unionpay.instMid" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="消息来源(msgSrc)">
          <el-input v-model="form.unionpay.msgSrc" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="来源编号（msgSrcId）">
          <el-input v-model="form.unionpay.msgSrcId" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="通讯秘钥 ">
          <el-input v-model="form.unionpay.Key" class="max-w460"></el-input>
        </el-form-item>
      </div>

      <!-- 汇付支付宝h5 -->
      <div v-if="['60-huifu_alipay_h5', '60-huifu_wxmp', '60-huifu_alipay_app','60-huifu_wxmn'].indexOf(form.payment_type) > -1">
        <el-form-item label="汇付appid" prop="adapay.app_id" :rules="[{required: true,message: '请输入汇付appid'}]">
          <el-input v-model="form.adapay.app_id" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="汇付支付渠道" prop="adapay.pay_channel" :rules="[{required: true,message: '请输入汇付支付渠道'}]">
          <el-input v-model="form.adapay.pay_channel" class="max-w460"></el-input>
        </el-form-item>
      </div>

      <!-- 康采余额支付 -->
      <div v-if="form.payment_type=='100-ini'">
        <el-form-item label="支付网址">
          <el-input v-model="form.ini.website" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="账户">
          <el-input v-model="form.ini.app_id" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="通讯ID">
          <el-input v-model="form.ini.api_app_id" class="max-w460"></el-input>
        </el-form-item>
  
        <el-form-item label="通讯秘钥">
          <el-input v-model="form.ini.Key" class="max-w460"></el-input>
        </el-form-item>

      </div>

      <el-form-item label="备注">
        <el-input type="textarea" :rows="4" v-model="form.remark" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="是否支持收款">
        <div>
          <el-radio v-model="form.pay_open" :label="1">是</el-radio>
          <el-radio v-model="form.pay_open" :label="0">否</el-radio>
        </div>
      </el-form-item>

      <el-form-item label="是否支持退款">
        <div>
          <el-radio v-model="form.refund_open" :label="1">是</el-radio>
          <el-radio v-model="form.refund_open" :label="0">否</el-radio>
        </div>
      </el-form-item>

      <el-form-item label="是否支持转账">
        <div>
          <el-radio v-model="form.transfer_open" :label="1">是</el-radio>
          <el-radio v-model="form.transfer_open" :label="0">否</el-radio>
        </div>
      </el-form-item>

      <el-form-item label="是否启用">
        <div>
          <el-radio v-model="form.status" :label="1">是</el-radio>
          <el-radio v-model="form.status" :label="0">否</el-radio>
        </div>
      </el-form-item>

      <el-form-item label="排序">
        <el-input v-model="form.sort" type="number" class="max-w460"></el-input>
        <div class="tips">数字越小越靠前</div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" :config="{ total: 3 }" @returnImgs="returnImgsFunc"></Upload>

  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';
  import Upload from '@/components/file/Upload';
  import PortApi from '@/api/port.js';
  export default {
    components:{
      Upload,
      PortApi
    },
    data() {
      return {
        /*form表单数据*/
        form: {
          port_id: 0,
          name: '',
          introduce: '',
          payment_type: '',
          label: '',
          sort: 1,
          file_id: 0,
          file_url: '',
          status: 1,
          remark: '',
          pay_open: 1,
          refund_open: 0,
          transfer_open: 0,
          value: '', // 支付类型值
          alipay: {
            appid: '',
            publicKey: '',
            privateKey: '',
          },
          wechatpay: {
            mchid: '',
            apikey: '',
            cert_pem: '',
            key_pem: '',
            wechatpay: '',
            wxapp_id: '',
            app_id: ''
          },
          unionpay:{
            mid: '',
            tid: '',
            instMid: '',
            msgSrc: '',
            msgSrcId: '',
            Key: ''
          },
          adapay:{
            app_id: '',
            pay_channel: ''
          },
          ini:{
            website:"",
            app_id: '',
            api_app_id:"",
            key:""
            
          },
          cash:{
        
          
          }
        },
        list: [],
        loading: false,
        // payment_arr: {
        //   balance: '余额支付',
        //   alipay: '支付宝支付',
        //   wechatpay: '微信支付',
        //   unionpay: '银联支付',
        // },
        payment_arr: {
          "10-balance": "余额",
          "20-wx_mn": "微信h5",
          "20-wx_mp": "微信小程序",
          "20-wx_app": "微信app",
          "40-alipay_h5": "支付宝h5",
          "40-alipay_app": "支付宝app",
          "60-huifu_alipay_h5": "汇付支付宝h5",
          "60-huifu_alipay_app": "汇付支付宝app",
          "60-huifu_wxmn": "汇付微信公众号",
          "60-huifu_wxmp": "汇付微信小程序",
          "100-ini":"互联互通",
          "130-cash":"现金支付",
          "140-credit": "授信",
        },
        isupload: false
      };
    },

    created() {
      this.getData();
    },

    methods: {
      getData() {
        let self = this;
        PortApi.portList({}, true)
          .then(res => {
            self.loading = false;
            self.list = res.data.list.data;
          })
          .catch(error => {});
      },
      choosePort(e){
        console.log(e)
      },
      //提交表单
      onSubmit() {
        let self = this;
        let form = {};
        form = Object.assign(form, this.form);
        let paymentType = form.payment_type.split("-");
        form.value = paymentType[0];
        form.payment_type = paymentType[1];
        form.label = paymentType[1];
        console.log(form,"保存的参数");

        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            SettingApi.addPayment(form, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，添加成功',
                  type: 'success'
                });
                 self.$router.push('/setting/payment/index');

              }).catch(error => {
                self.loading = false;
              });
          }
        });
      },

      /*选择图片*/
      chooseImg(){
        this.isupload=true;
      },

      /*关闭选择图片*/
      returnImgsFunc(e){
        this.isupload=false;
        this.form.file_id = e[0].file_id;
        this.form.file_url = e[0].file_path;
      }

    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/payment/add.vue